import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import ErrorBoundary from "./components/common/ErrorBoundary";

// Lazy load pages
const Gateway = lazy(() => import("./pages/Gateway"));
const DevPortfolio = lazy(() => import("./pages/DevPortfolio"));
const VideoPortfolio = lazy(() => import("./pages/VideoPortfolio"));
const Admin = lazy(() => import("./pages/Admin"));
const AdminLogin = lazy(() => import("./pages/AdminLogin"));

// Dedicated sub-pages (List)
const DevPengalamanPage = lazy(() => import("./pages/dev/PengalamanPage"));
const DevPortofolioPage = lazy(() => import("./pages/dev/PortofolioPage"));
const DevSertifikasiPage = lazy(() => import("./pages/dev/SertifikasiPage"));

const VideoPengalamanPage = lazy(() => import("./pages/video/PengalamanPage"));
const VideoPortofolioPage = lazy(() => import("./pages/video/PortofolioPage"));
const VideoSertifikasiPage = lazy(() => import("./pages/video/SertifikasiPage"));

// Dedicated sub-pages (Detail)
const DevPengalamanDetailPage = lazy(() => import("./pages/dev/PengalamanDetailPage"));
const DevPortofolioDetailPage = lazy(() => import("./pages/dev/PortofolioDetailPage"));
const DevSertifikasiDetailPage = lazy(() => import("./pages/dev/SertifikasiDetailPage"));

const VideoPengalamanDetailPage = lazy(() => import("./pages/video/PengalamanDetailPage"));
const VideoPortofolioDetailPage = lazy(() => import("./pages/video/PortofolioDetailPage"));
const VideoSertifikasiDetailPage = lazy(() => import("./pages/video/SertifikasiDetailPage"));

function App() {
  return (
    <ErrorBoundary>
      <Suspense
        fallback={
          <div className="min-h-screen flex items-center justify-center bg-nb-bg">
            <div className="flex flex-col items-center gap-4">
              <div className="w-12 h-12 border-4 border-nb-fg border-t-nb-accent animate-spin" />
              <span className="font-mono text-xs uppercase tracking-[0.15em] text-nb-muted">
                [ LOADING... ]
              </span>
            </div>
          </div>
        }
      >
        <Routes>
          {/* Gateway page */}
          <Route path="/" element={<Gateway />} />

          {/* Software Developer routes */}
          <Route path="/dev" element={<DevPortfolio />} />
          <Route path="/dev/pengalaman" element={<DevPengalamanPage />} />
          <Route path="/dev/pengalaman/:id" element={<DevPengalamanDetailPage />} />
          <Route path="/dev/portofolio" element={<DevPortofolioPage />} />
          <Route path="/dev/portofolio/:id" element={<DevPortofolioDetailPage />} />
          <Route path="/dev/sertifikasi" element={<DevSertifikasiPage />} />
          <Route path="/dev/sertifikasi/:id" element={<DevSertifikasiDetailPage />} />

          {/* Video Editor routes */}
          <Route path="/video" element={<VideoPortfolio />} />
          <Route path="/video/pengalaman" element={<VideoPengalamanPage />} />
          <Route path="/video/pengalaman/:id" element={<VideoPengalamanDetailPage />} />
          <Route path="/video/portofolio" element={<VideoPortofolioPage />} />
          <Route path="/video/portofolio/:id" element={<VideoPortofolioDetailPage />} />
          <Route path="/video/sertifikasi" element={<VideoSertifikasiPage />} />
          <Route path="/video/sertifikasi/:id" element={<VideoSertifikasiDetailPage />} />

          {/* Admin routes */}
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/login" element={<AdminLogin />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;
